import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    api
      .get("/auth/me")
      .then((r) => alive && setUser(r.data))
      .catch(() => alive && setUser(false))
      .finally(() => alive && setReady(true));
    return () => {
      alive = false;
    };
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const driverLogin = async (identifier, password) => {
    try {
      const { data } = await api.post("/driver/auth/login", { identifier, password });
      setUser(data);
      return { ok: true, data };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const setDriverPassword = async (new_password, confirm_password) => {
    try {
      await api.post("/driver/set-password", { new_password, confirm_password });
      const refreshed = await api.get("/auth/me");
      setUser(refreshed.data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, driverLogin, setDriverPassword, logout }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
